const tenantInitialOu = {
  path: '',
  team_drive_id: '',
  folder_hierarchy: '',
  permissioned_emails: [],
};

export default tenantInitialOu;
